const EMAIL_REGEX = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

export const isEmailValid = (email: string) => {
    if (email && email.length > 0) {
        return EMAIL_REGEX.test(email);
    }
    return false;
}
